const SET_ACCESS_TOKEN = 'common/SET_ACCESS_TOKEN';

const SOCIAL_SIGN_IN = 'common/SOCIAL_SIGN_IN';

const FETCH_MY_INFO = 'common/FETCH_MY_INFO';

const UPDATE_ME = 'common/UPDATE_ME';

const CHANGE_MY_INFO = 'common/CHANGE_MY_INFO';

const UNREGISTER_USER = 'common/UNREGISTER_USER';

const POST_MESSAGES = 'common/POST_MESSAGES';

const SIGN_OUT = 'common/SIGN_OUT';

const RESET_USER = 'common/RESET_USER';

const SHOW_STORAGE_WARNING = 'common/SHOW_STORAGE_WARNING';

const HIDE_STORAGE_WARNING = 'common/SHOW_STORAGE_WARNING';

const SET_EXPERIMENTS = 'common/SET_EXPERIMENTS';

const UPDATE_AB_TEST_DATA_RECEIVED = 'common/UPDATE_AB_TEST_DATA_RECEIVED';

const SET_AD_LOAD_STATUS = 'common/SET_AD_LOAD_STATUS';

const SET_SESSION_ID = 'common/SET_SESSION_ID';

const CHECK_PROMOTIONS = 'common/CHECK_PROMOTIONS';

const SET_PROMOTIONS = 'common/SET_PROMOTIONS';

const SET_SHOW_AD_TAP_COUNT = 'common/SET_SHOW_AD_TAP_COUNT';

const FETCH_FIREBASE_TOKEN = 'common/FETCH_FIREBASE_TOKEN';

const FETCH_USERS_MARKET_ITEMS = 'common/FETCH_USERS_MARKET_ITEMS';

const FETCH_USER_FANS = 'common/FETCH_USER_FANS';

const FETCH_USER_SETTING = 'common/FETCH_USER_SETTING';
const SET_USER_SETTING = 'common/SET_USER_SETTING';

const FETCH_STORY_AD = 'common/FETCH_STORY_AD';
const FETCH_STORY_AD_FULL = 'common/FETCH_STORY_AD_FULL';

const SET_STORY_AD_FULL = 'common/SET_STORY_AD_FULL';
const VIEW_STORY_AD_FULL = 'common/VIEW_STORY_AD_FULL';
const RESET_STORY_AD_FULL = 'common/RESET_STORY_AD_FULL';

const FETCH_LATEST_MY_STORY = 'common/FETCH_LATEST_MY_STORY';

const SET_VALUE = 'common/SET_VALUE';
const SET_LOADING = 'common/SET_LOADING';

const FETCH_VOUCHERS = 'common/FETCH_VOUCHERS';

const FETCH_VOUCHER_RECOMMENDATION = 'common/FETCH_VOUCHER_RECOMMENDATION';

export default {
  SET_ACCESS_TOKEN,
  SOCIAL_SIGN_IN,
  FETCH_MY_INFO,
  UPDATE_ME,
  CHANGE_MY_INFO,
  UNREGISTER_USER,
  POST_MESSAGES,
  SIGN_OUT,
  RESET_USER,
  SHOW_STORAGE_WARNING,
  HIDE_STORAGE_WARNING,
  SET_EXPERIMENTS,
  UPDATE_AB_TEST_DATA_RECEIVED,
  SET_AD_LOAD_STATUS,
  SET_SESSION_ID,
  CHECK_PROMOTIONS,
  SET_PROMOTIONS,
  SET_SHOW_AD_TAP_COUNT,
  FETCH_FIREBASE_TOKEN,
  FETCH_USERS_MARKET_ITEMS,
  FETCH_USER_FANS,
  FETCH_USER_SETTING,
  SET_USER_SETTING,
  FETCH_STORY_AD,
  FETCH_STORY_AD_FULL,
  SET_STORY_AD_FULL,
  VIEW_STORY_AD_FULL,
  RESET_STORY_AD_FULL,
  FETCH_LATEST_MY_STORY,
  SET_VALUE,
  SET_LOADING,
  FETCH_VOUCHERS,
  FETCH_VOUCHER_RECOMMENDATION,
};



// WEBPACK FOOTER //
// ./src/app/redux/common/types.js